import React from 'react';
import { LoaderIcon } from 'react-hot-toast';

export const Loader = () => {
  return (
    <span class="loader"></span>
  )
}

export const ButtonLoader = () => {
  return (
    <i class="fas fa-spinner fa-spin"></i>
  )
}
